import React, {useLayoutEffect, useRef} from 'react'
import {Stack, HStack, Box, Flex, Text, Input, Select, Heading, Checkbox,} from '@chakra-ui/react'
import {InputLabel} from '../../../../../components/Theme'
import NavigateModal from '../NavigateModal'
import {ReactComponent as DollarIcon} from "../../../../../assets/Icons/dollarIcon.svg";
import {ReactComponent as PendingIcon} from "../../../../../assets/Icons/pendingIcon.svg";
import {ReactComponent as ArrowDownIcon} from "../../../../../assets/downArrow.svg";
import CustomSelectMultiple from "../../../Parts/CustomSelectMultiple";
import styles from "../../styles";
import Loading from "../../../../Loading";
import {LAMP_CATEGORY} from "../../../../../constants/utils";
import {expandedSearchStyles} from "../../../../../constants/expandedSearch";

const {colors: expandedSearchColors, textColors: expandedSearchTextColors} = expandedSearchStyles.lamp;

const View = ({
                  buyAmerican,
                  isFetching,
                  setBuyAmerican,
                  setType,
                  setCertifications,
                  setExpandedSearch,
                  customPricing,
                  setCustomPricing,
                  validate,
                  isFetchingBids,
                  projectId,
                  handleSelect,
                  luminaire,
                  certifications,
                  expandedSearch,
                  selectedItems,
                  lampDisabled,
                  description,
                  lamp,
                  setLamp,
                  setSelectedItems,
                  fetchedDataLamp,
                  create,
                  isOpen,
                  setIsOpen,
                  refetch,
                  fromAll,
                  selectAll,
                  lampAirtable,
                  handleSelectAll,
                  setLampAirtable,
              }) => {
    const resultsListRef = useRef(null)
    const filteredLamps = (fetchedDataLamp?.filter((item) => validate(item) === true) ?? [])
        .sort((a, b) => Number(expandedSearch.includes(b.fields['Category']))
            - Number(expandedSearch.includes(a.fields['Category'])))
    const expandedSearchOptions = LAMP_CATEGORY
    const expandedSearchKey = JSON.stringify(expandedSearch)
    const expandedResultsKey = JSON.stringify(filteredLamps
        .filter(item => expandedSearch.includes(item.fields['Category']))
        .map(item => item.id))

    useLayoutEffect(() => {
        if (isOpen && resultsListRef.current) {
            resultsListRef.current.scrollTop = 0
        }
    }, [isOpen, expandedSearchKey, expandedResultsKey])

    return (
                          <Stack spacing="5">
                              <NavigateModal
                                  label={description}
                                  leftAction={() => {
                                      create()
                                      setType('fixture')
                                  }}
                                  rightAction={() => {
                                      create()
                                      setType('power')
                                  }}
                                  left="Fixture"
                                  right="Power Supply"/>
                              <HStack w="full" justifyContent="center" position="relative" alignItems="center" py={5}>
                                  <Box position="absolute" bg="#A9A9A9" w="full" h="1px"/>
                                  <Box px="2" position="relative" bg="white" textTransform="uppercase" fontWeight="400" fontSize="xl"
                                       color="#2C628D" as="span">
                                      lamp details
                                  </Box>
                              </HStack>
                              <HStack spacing="5" alignItems="flex-end">
                                  <InputLabel
                                      height='46px'
                                      maxW="203px"
                                      disabled={fromAll || isFetching || isFetchingBids}
                                      type="number"
                                      value={lamp?.recomendedLampQty ? lamp?.recomendedLampQty : ''}
                                      onChange={(e) => setLamp({
                                          ...lamp,
                                          recomendedLampQty: e.target.value,
                                      })}
                                      pattern="[0-9]*"
                                      label="QTY/Fixture"/>
                                  <Box
                                      position="relative"
                                      width="100%"
                                      height="46px"
                                      css={styles.styledList}
                                  >
                                      <Flex
                                          alignItems="center"
                                          onClick={() => {
                                              if (lampDisabled) return;

                                              refetch();

                                              setIsOpen(!isOpen);
                                          }}
                                          bg="#EEEEEE"
                                          cursor="pointer"
                                          border="1px solid #ccc"
                                          borderBottom="none"
                                          position="relative"
                                          borderBottomLeftRadius="6px"
                                          borderBottomRightRadius="6px"
                                          fontSize="18px"
                                          p="10px 30px"
                                      >
                                          {lampAirtable?.length > 0
                                              ? lampAirtable
                                                  .map(
                                                      item => item.fields["FE Product Description"]
                                                  )
                                                  .join(", ")
                                              : "No Change"}

                                          <ArrowDownIcon
                                              style={{
                                                  position: "absolute",
                                                  right: "10px",
                                                  top: "18px",
                                              }}
                                          />
                                      </Flex>

                                      {isOpen && (
                                          <ul
                                              ref={resultsListRef}
                                              style={{
                                                  position: "absolute",
                                                  top: "99%",
                                                  left: 0,
                                                  right: 0,
                                                  border: "1px solid #ccc",
                                                  margin: 0,
                                                  padding: 0,
                                                  listStyle: "none",
                                                  backgroundColor: "white",
                                                  zIndex: 1000,
                                                  maxHeight: "500px",
                                                  overflowY: "auto",
                                              }}
                                          >
                                              {isFetching && filteredLamps.length === 0 ? (
                                                  <li
                                                      style={{
                                                          display: "flex",
                                                          justifyContent: "center",
                                                          padding: "20px",
                                                      }}
                                                  >
                                                      <Loading height="50px" />
                                                  </li>
                                              ) : (
                                                  <>
                                                      <li
                                                          style={{
                                                              cursor: "pointer",
                                                              padding: "8px 8px 0 30px",
                                                          }}
                                                          onClick={() => {
                                                              setLampAirtable([]);
                                                              setSelectedItems([]);
                                                          }}
                                                      >
                                                          Select
                                                      </li>

                                                      {customPricing.lamp && (
                                                          <li
                                                              style={{
                                                                  padding: "8px 8px 0 8px",
                                                                  cursor: "pointer",
                                                                  position: "relative",
                                                                  display: "flex",
                                                                  alignItems: "center",
                                                              }}
                                                          >
                                                              <Checkbox
                                                                  _checked={{
                                                                      "& .chakra-checkbox__control": {
                                                                          background: "#FFE68D",
                                                                          boxShadow: "none",
                                                                          borderColor: "black",
                                                                          outline: "none",
                                                                      },
                                                                  }}
                                                                  _hover={{
                                                                      "& .chakra-checkbox__control": {
                                                                          background: "#FFE68D",
                                                                          boxShadow: "none",
                                                                          borderColor: "black",
                                                                          outline: "none",
                                                                      },
                                                                  }}
                                                                  _focus={{
                                                                      "& .chakra-checkbox__control": {
                                                                          background: "#FFE68D",
                                                                          borderColor: "black",
                                                                          boxShadow: "none",
                                                                      },
                                                                  }}
                                                                  _focusVisible={{
                                                                      "& .chakra-checkbox__control": {
                                                                          outline: "none",
                                                                          boxShadow: "none",
                                                                      },
                                                                  }}
                                                                  iconColor="black"
                                                                  isChecked={selectAll}
                                                                  mr="8px"
                                                                  size="lg"
                                                                  borderColor="#222222"
                                                                  onChange={handleSelectAll}
                                                              >
                                                                  <Heading m={0} fontSize="14px">
                                                                      Select All
                                                                  </Heading>
                                                              </Checkbox>
                                                          </li>
                                                      )}
                                                      {filteredLamps.length === 0 && (
                                                          <li
                                                              style={{
                                                                  color: '#666666',
                                                                  cursor: 'default',
                                                                  padding: '16px 30px'
                                                              }}>
                                                          </li>
                                                      )}
                                                      {filteredLamps
                                                          .map(item => (
                                                              <li
                                                                  className="list-item"
                                                                  key={item.id}
                                                                  style={{
                                                                      backgroundColor: lampAirtable?.length > 0 && item.id === lampAirtable[0].id
                                                                          ? "#A9A9A9"
                                                                          : expandedSearch.includes(item.fields["Category"])
                                                                              ? expandedSearchColors[item.fields["Category"]]
                                                                              : "transparent",
                                                                      color: lampAirtable?.length > 0 && item.id === lampAirtable[0].id
                                                                          ? '#222222'
                                                                          : expandedSearch.includes(item.fields['Category'])
                                                                              ? expandedSearchTextColors[item.fields['Category']]
                                                                              : 'inherit',
                                                                      padding: customPricing.lamp
                                                                          ? "8px 8px 0 8px"
                                                                          : "8px 30px 0 30px",
                                                                      cursor: "pointer",
                                                                      position: "relative",
                                                                      display: "flex",
                                                                      alignItems: "center",
                                                                  }}
                                                              >
                                                                  {customPricing.lamp ? (
                                                                      <>
                                                                          {item.fields["Bid Status"] ===
                                                                          "pending" ||
                                                                          item.fields["Bid Status"] ===
                                                                          "accepted" ? (
                                                                              <Flex
                                                                                  mr="8px"
                                                                                  border="2px solid black"
                                                                                  alignItems="center"
                                                                                  justifyContent="center"
                                                                                  borderRadius="2px"
                                                                                  bg={
                                                                                      item.fields[
                                                                                          "Bid Status"
                                                                                          ] ===
                                                                                      "pending"
                                                                                          ? "#FFE68D"
                                                                                          : "#8FCF74"
                                                                                  }
                                                                                  width="20px"
                                                                                  height="20px"
                                                                              >
                                                                                  {item.fields[
                                                                                      "Bid Status"
                                                                                      ] === "pending" ? (
                                                                                      <PendingIcon />
                                                                                  ) : (
                                                                                      <DollarIcon />
                                                                                  )}
                                                                              </Flex>
                                                                          ) : (
                                                                              <Checkbox
                                                                                  size="lg"
                                                                                  iconColor="black"
                                                                                  borderColor="#222222"
                                                                                  isChecked={selectedItems.includes(
                                                                                      item.id
                                                                                  )}
                                                                                  onChange={() =>
                                                                                      handleSelect(
                                                                                          item.id
                                                                                      )
                                                                                  }
                                                                                  mr="8px"
                                                                              />
                                                                          )}

                                                                          <Text
                                                                              as="span"
                                                                              onClick={() => {
                                                                                  setLampAirtable(
                                                                                      prev =>
                                                                                          prev.some(
                                                                                              lamp =>
                                                                                                  lamp.id ===
                                                                                                  item.id
                                                                                          )
                                                                                              ? prev.filter(
                                                                                                  lamp =>
                                                                                                      lamp.id !==
                                                                                                      item.id
                                                                                              )
                                                                                              : [item]
                                                                                  );
                                                                              }}
                                                                              fontSize="18px"
                                                                          >
                                                                              {
                                                                                  item.fields[
                                                                                      "FE Product Description"
                                                                                      ]
                                                                              }
                                                                          </Text>

                                                                          <Text
                                                                              as="span"
                                                                              ml={2}
                                                                              fontSize="18px"
                                                                          >
                                                                              {item.fields[
                                                                                  "SU PPU ($) Custom"
                                                                                  ]
                                                                                  ? `$${item.fields["SU PPU ($) Custom FE"]}`
                                                                                  : ""}
                                                                          </Text>
                                                                      </>
                                                                  ) : (
                                                                      <>
                                                                          <Text
                                                                              as="span"
                                                                              fontSize="18px"
                                                                              onClick={() => {
                                                                                  setLampAirtable(
                                                                                      prev =>
                                                                                          prev.some(
                                                                                              lamp =>
                                                                                                  lamp.id ===
                                                                                                  item.id
                                                                                          )
                                                                                              ? prev.filter(
                                                                                                  lamp =>
                                                                                                      lamp.id !==
                                                                                                      item.id
                                                                                              )
                                                                                              : [item]
                                                                                  );
                                                                              }}
                                                                          >
                                                                              {
                                                                                  item.fields[
                                                                                      "FE Product Description"
                                                                                      ]
                                                                              }
                                                                          </Text>

                                                                          <Text
                                                                              as="span"
                                                                              ml={2}
                                                                              fontSize="18px"
                                                                          >
                                                                              {item.fields[
                                                                                  "SU PPU ($) Custom"
                                                                                  ]
                                                                                  ? `$${item.fields["SU PPU ($) Custom FE"]}`
                                                                                  : `$${Number(
                                                                                      item.fields[
                                                                                          "FE PPU ($)"
                                                                                          ]
                                                                                  ).toFixed(2)}`}
                                                                          </Text>
                                                                      </>
                                                                  )}
                                                              </li>
                                                          ))}
                                                  </>
                                              )}
                                          </ul>
                                      )}
                                  </Box>
                              </HStack>
                              <HStack w="full" justifyContent="center" position="relative" alignItems="center" py={5}>
                                  <Box position="absolute" bg="#A9A9A9" w="full" h="1px"/>
                                  <Box px="2" position="relative" bg="white" textTransform="uppercase" fontWeight="400" fontSize="xl"
                                       color="#2C628D" as="span">
                                      filters
                                  </Box>
                              </HStack>
                              <HStack justifyContent='space-between'>
                                  <Box/>
                                  <HStack spacing='7'>
                                      <Heading fontSize='14px' textAlign='center' m={0} width='360px'>MINIMUM</Heading>
                                      <Heading fontSize='14px' textAlign='center' m={0} width='360px'>MAXIMUM</Heading>
                                  </HStack>
                              </HStack>
                              <HStack spacing='5' justifyContent='space-between'>
                                  <Heading color='#2C628D' fontWeight='400' fontSize='14px' m={0}>
                                      Wattage
                                  </Heading>
                                  <HStack spacing='7'>
                                      <Input
                                          fontSize='18px'
                                          height='50px'
                                          value={lamp?.lampRecomendedWattageMinimum}
                                          onChange={(e) => {
                                              setLamp({...lamp, lampRecomendedWattageMinimum: e.target.value})
                                          }}
                                          width='360px'
                                          border='1px solid #A9A9A9 !important'/>
                                      <Input
                                          fontSize='18px'
                                          height='46px'
                                          value={lamp?.lampRecomendedWattageMaximum}
                                          onChange={(e) => {
                                              setLamp({...lamp, lampRecomendedWattageMaximum: e.target.value})
                                          }}
                                          width='360px'
                                          border='1px solid #A9A9A9 !important'/>
                                  </HStack>
                              </HStack>
                              <HStack justifyContent='space-between' spacing='5'>
                                  <Heading m={0} color='#2C628D' fontSize='14px' fontWeight='400'>Lumens</Heading>
                                  <HStack spacing='7'>
                                      <Input
                                          fontSize='18px'
                                          height='50px'
                                          value={lamp?.lampRecomendedLumensMinimum}
                                          onChange={(e) => {
                                              setLamp({...lamp, lampRecomendedLumensMinimum: e.target.value})
                                          }}
                                          width='360px'
                                          border='1px solid #A9A9A9 !important'/>
                                      <Input
                                          fontSize='18px'
                                          height='50px'
                                          value={lamp?.lampRecomendedLumensMaximum}
                                          onChange={(e) => {
                                              setLamp({...lamp, lampRecomendedLumensMaximum: e.target.value})
                                          }}
                                          width='360px'
                                          border='1px solid #A9A9A9 !important'/>
                                  </HStack>
                              </HStack>
                              <HStack justifyContent='space-between' spacing='5'>
                                  <Heading m={0} color='#2C628D' fontSize='14px' fontWeight='400'>Color</Heading>
                                  <HStack spacing='7'>
                                      <Input
                                          fontSize='18px'
                                          height='50px'
                                          value={lamp?.lampRecomendedColorMinimum}
                                          onChange={(e) => {
                                              setLamp({...lamp, lampRecomendedColorMinimum: e.target.value})
                                          }}
                                          width='360px'
                                          border='1px solid #A9A9A9 !important'/>
                                      <Input
                                          fontSize='18px'
                                          height='50px'
                                          value={lamp?.lampRecomendedColorMaximum}
                                          onChange={(e) => {
                                              setLamp({...lamp, lampRecomendedColorMaximum: e.target.value})
                                          }}
                                          width='360px'
                                          border='1px solid #A9A9A9 !important'/>
                                  </HStack>
                              </HStack>
                              <HStack justifyContent='space-between' spacing='5'>
                                  <Heading m={0} color='#2C628D' fontSize='14px' fontWeight='400'>Price</Heading>
                                  <HStack spacing='7'>
                                      <Input
                                          fontSize='18px'
                                          height='50px'
                                          value={lamp?.lampRecomendedPriceMinimum}
                                          onChange={(e) => {
                                              setLamp({...lamp, lampRecomendedPriceMinimum: e.target.value})
                                          }}
                                          width='360px'
                                          border='1px solid #A9A9A9 !important'/>
                                      <Input
                                          fontSize='18px'
                                          height='50px'
                                          value={lamp?.lampRecomendedPriceMaximum}
                                          onChange={(e) => {
                                              setLamp({...lamp, lampRecomendedPriceMaximum: e.target.value})
                                          }}
                                          border='1px solid #A9A9A9 !important'
                                          width='360px'/>
                                  </HStack>
                              </HStack>
                              <HStack spacing='73px' justifyContent='space-between'>
                                  <Heading fontWeight='400' m={0} color='#2C628D' fontSize='14px'>
                                      Certification
                                  </Heading>
                                  <CustomSelectMultiple
                                      width='748px'
                                      value={certifications}
                                      setValue={setCertifications}
                                      options={["UL Listed", "DLC Approved","Energy Star","FCC","ETL","RoHS","CE Marketing","Other"]}
                                  />
                              </HStack>
                              <HStack justifyContent='space-between' spacing='5'>
                                  <Heading m={0} color='#2C628D' fontSize='14px' fontWeight='400'>Dimmability</Heading>
                                  <Select
                                      fontSize='18px'
                                      height='50px'
                                      value={lamp?.lampRecomendedDimmability}
                                      onChange={(e) => {
                                          setLamp({...lamp, lampRecomendedDimmability: e.target.value})
                                      }}
                                      placeholder='Select'
                                      width='748px'
                                      border='1px solid #A9A9A9 !important'>
                                      <option value="None">None</option>
                                      <option value="1% Dimmable">1% Dimmable</option>
                                      <option value="5% Dimmable">5% Dimmable</option>
                                      <option value="10% Dimmable">10% Dimmable</option>
                                      <option value="Leading Edge (TRIAC)">Leading Edge (TRIAC)</option>
                                      <option value="Trailing Edge (Electronic)">Trailing Edge (Electronic)</option>
                                      <option value="1-10V Dimmable">1-10V Dimmable</option>
                                      <option value="0-10V Dimmable">0-10V Dimmable</option>
                                  </Select>
                              </HStack>
                              <HStack spacing='73px' justifyContent='space-between'>
                                  <Heading fontWeight='400' m={0} color='#2C628D' fontSize='14px'>
                                      Expanded Search
                                  </Heading>
                                  <CustomSelectMultiple
                                      width='748px'
                                      value={expandedSearch}
                                      setValue={setExpandedSearch}
                                      options={expandedSearchOptions}
                                      optionColors={expandedSearchColors}
                                      optionIconColors={expandedSearchTextColors}
                                  />
                              </HStack>
                              <HStack spacing='5' justifyContent='space-between'>
                                  <HStack spacing='60px'>
                                      <Heading fontWeight='400' m={0} color='#2C628D' fontSize='14px'>
                                          Show Custom <br/>Price Options
                                      </Heading>
                                      <Checkbox
                                          _checked={{
                                              "& .chakra-checkbox__control": {background: "#D4E6FF", boxShadow: 'none'}
                                          }}
                                          _hover={{
                                              "& .chakra-checkbox__control": {background: "#D4E6FF", boxShadow: 'none'}
                                          }}
                                          iconColor='black'
                                          onChange={(e) => {
                                              refetch()
                                              if (!e.target.isChecked) {
                                                  setSelectedItems([])
                                                  setLampAirtable([])
                                              }
                                              setCustomPricing({...customPricing, lamp: !customPricing.lamp})
                                          }}
                                          isChecked={customPricing.lamp} color='#A9A9A9' width='20px' height='20px'
                                          borderColor='#2C628D'>
                                          Yes
                                      </Checkbox>
                                  </HStack>
                                  <HStack spacing='40px' width='40%'>
                                      <Heading fontWeight='400' m={0} color='#2C628D' fontSize='14px'>
                                          Buy American
                                      </Heading>
                                      <Checkbox
                                          _checked={{
                                              "& .chakra-checkbox__control": {background: "#D4E6FF", boxShadow: 'none'}
                                          }}
                                          _hover={{
                                              "& .chakra-checkbox__control": {background: "#D4E6FF", boxShadow: 'none'}
                                          }}
                                          onChange={() => {
                                              setBuyAmerican(!buyAmerican)
                                          }}
                                          isChecked={buyAmerican}
                                          iconColor='black'
                                          color='#A9A9A9' width='20px' height='20px' borderColor='#2C628D'>
                                          Yes
                                      </Checkbox>
                                  </HStack>
                              </HStack>
                          </Stack>
                      )
}

export default View
